import React, { useContext, useEffect, useRef, useState } from 'react';
import { useT } from '../../../../../../helpers/i18n';
import useCollapse from 'react-collapsed';
import { config } from '@fortawesome/fontawesome-svg-core'
import { faSwimmingPool } from '@fortawesome/pro-regular-svg-icons'
import { faBed as fasBed, faHotTub as fasHotTub, faShower as fasShower, faUsers as fasUsers } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../../../../helpers/class/Checkers';
import Methods from '../../../../../../helpers/class/Methods';

import '@fortawesome/fontawesome-svg-core/styles.css'

config.autoAddCss = false;

import { useInViewport } from 'react-in-viewport';
import { useSelector } from 'react-redux';

import * as appContext from '../../../../../AppContext';
import ReadMoreText from '../../../../../ReadMoreText';

export default function DetailDesc ( props ) {
  const t = useT();
  const [ isPublicDomain, setIsPublicDomain ] = useState( useSelector( state => state['appSettings']['isPublicDomain']) )
  const [ publicDomain, setPublicDomain ] = useState( 0 );

  useEffect( () => {
    setPublicDomain( isPublicDomain )
  }, [ isPublicDomain, setPublicDomain ])
    
  const config = { disconnectOnLeave: false };
  const options = {  };
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
    myRef,
    options,
    config,
    props
  );

  const array = [
    { key: 'guests', value: props.details.capacity },
    { key: 'bedrooms', value: props.details.bedrooms },
    { key: 'bathrooms', value: props.details.bathrooms },
    { key: 'pools', value: props.details.pools },
    { key: 'jacuzzi', value: props.details.jacuzzi },
  ];

  const [ isExpanded, setExpanded ] = React.useState( false );
  const { getCollapseProps } = useCollapse({
    isExpanded
  });

  const [ propertyTitle, setPropertyTitle ] = useState( props.details.property_title )

  const alternative_title = props.details.alternative_title

  useEffect( () => {
    if ( alternative_title != undefined && publicDomain==1 ) {
      if ( alternative_title.length>0 ) {
        setPropertyTitle( alternative_title )
      }
    }
  }, [ publicDomain, setPropertyTitle, alternative_title ])

  const b2description = props.details.b2b_description

  const isHtmlEmpty = (html) => {
    if (!html) return true

    const text = html.replace(/<[^>]*>/g, '').trim()
    return text === ''
  }
  
  const isPasswordProtectionEnabled = Checkers.valueToBoolean(props.passwordEnabled)

  let viewPortResult = null;
  // if(!inViewport){
  //     viewPortResult =
  //         <>
  //             <Skeleton height={30} className="col-8 col-sm-6 col-md-4 b-rad-md mb-1" />
  //             <Skeleton height={42} className="col-8 col-sm-6 col-md-4 b-rad-md mb-2"/>
  //             <Skeleton height={30} className="col-12 col-sm-8 col-md-6 b-rad-md mb-1"/>
  //             <Skeleton height={150} className="col-12 b-rad-lg"/>
  //         </>
  //     ;
  // } else {
  viewPortResult =
    <>
      {/*<p className="text-justify">*/}
      {/*  <strong>{props.details.motto}</strong>. {props.details.description}*/}
      {/*</p>*/}
      {/*<div {...getCollapseProps({})}>*/}
      {
        publicDomain == 1 && props.details.whitelabel_description.length > 0 ?
          <>
            <ReadMoreText className={'text-md-justify'} lines={14} text={props.details.whitelabel_description } isDesktop={props.isDesktop}/>
            {/*<div dangerouslySetInnerHTML={{ __html: }}/>*/}
          </>
        // :
        // <>
        //   <div dangerouslySetInnerHTML={{ __html: Methods.htmlTagReplacer( props.details.desc_brief, 'b', 'strong' ) }}/>
        //   <div dangerouslySetInnerHTML={{ __html: Methods.htmlTagReplacer( props.details.desc_details, 'b', 'strong' ) }}/>
        // </>
          :
          <>

            <p className="text-justify">
              <strong>{props.details.motto}</strong>{Checkers.isValidString(props.details.motto) ? ". " : ""}{props.details.description}
            </p>
            <div {...getCollapseProps({})}>
              <>
                <div dangerouslySetInnerHTML={{ __html: Methods.htmlTagReplacer( props.details.desc_brief, 'b', 'strong' ) }}/>
                <div dangerouslySetInnerHTML={{ __html: Methods.htmlTagReplacer( props.details.desc_details, 'b', 'strong' ) }}/>
              </>
            </div>
            {
              ( props.details.desc_brief.length > 0 || props.details.desc_details.length > 0 ) &&
              <p className="">
                <button className="btn-link text-link" onClick={() => setExpanded( ( value ) => !value )}>
                  {
                    isExpanded ? t('common.readLess') : t('property.overview')
                  }
                </button>
              </p>
            }
          </>

      }
    </>
  ;
  // }

  return (
    <div ref={myRef} id="pro_detail_desc" className="row full-width no-margin pb-5">
      { viewPortResult }
      {isPasswordProtectionEnabled && !isHtmlEmpty(b2description) ? <div dangerouslySetInnerHTML={{ __html: b2description }} /> : <></>}
    </div>
  )
}
